import * as React from "react";
import { lazy, Suspense } from "react";
import * as ReactDOM from "react-dom";
import Loading from "@Tmp/Loading";

export function InitializeReactWidget<Element, Import extends Promise<any>>(
    $element: Element,
    imported: Import
) {
    //@ts-ignore
    class TmpWidget extends elementorModules.frontend.handlers.Base {
        onInit(...args) {
            super.onInit(...args);
            const w = this;

            //@ts-ignore
            const id_attr = w.$element.find(".tmp-react-element").attr("id");
            const rootElement = document.getElementById(id_attr);
            /*const pageId = parseInt(
                w.$element.closest("*[data-elementor-id]").attr("data-elementor-id")
            );*/

            const shouldHydrate = rootElement?.classList.contains("tmp-react-element-ssr");

            rootElement?.setAttribute(
                "data-tmp-react-render-method",
                shouldHydrate ? "hydrate" : "render"
            );

            if (shouldHydrate) {
                imported.then((imp) => {
                    const Widget = imp.default;
                    //@ts-ignore
                    ReactDOM.hydrate(
                        <Widget
                            //@ts-ignore
                            {...(window["tmp_widget_props_" + w.getID()] ?? {})}
                            //@ts-ignore
                            id={w.getID()}
                        />,
                        rootElement
                    );
                });
            } else {
                const Widget = lazy(() => imported);

                //@ts-ignore
                ReactDOM.render(
                    <Suspense fallback={<Loading />}>
                        <Widget
                            //@ts-ignore
                            {...(window["tmp_widget_props_" + w.getID()] ?? {})}
                            //@ts-ignore
                            id={w.getID()}
                        />
                    </Suspense>,
                    rootElement
                );
            }
        }
    }

    elementorFrontend.elementsHandler.addHandler(TmpWidget, {
        $element,
    });
}
